import request from "../request";

export const getUsers = (filter) =>
  request.post(`/user/list`, { filter }).then((res) => res);

export const getUsersSkipLimit = (skip = 0, limit = 5, filter) =>
  request.post(`/user/list/skip/${skip}/limit/${limit}`, { filter }).then((res) => res);

export const getUsersByRoleIdSkipLimit = (roleId, skip = 0, limit = 5, filter) =>
  request.post(`/user/role/${roleId}/list/skip/${skip}/limit/${limit}`, { filter }).then((res) => res);

export const getUserById = (id) =>
  request.get(`user/${id}`).then((res) => res);

export const createUser = (data) =>
  request.post("user", data).then((res) => res);

export const updateUser = (id, data) =>
  request.put(`user/${id}`, data).then((res) => res);

export const archiveUser = (id) =>
  request.delete(`user/${id}/archive`).then((res) => res);

export const deleteUser = (id) =>
  request.delete(`user/${id}`).then((res) => res);

export const resetPassword = (id) =>
  request.put(`user/password-reset/${id}`).then((res) => res);

export const bulkResetPassword = (data) => 
  request.put(`user/password-reset/bulk`, data).then((res) => res);

export const invite = (id) =>
  request.put(`user/invitation/${id}`).then((res) => res);

export const bulkInvite = (data) =>
  request.post(`user/invitation/bulk`, data).then((res) => res);

export const updateBatchRoles = (data) =>
  request.put(`user/batch/roles`, data).then((res) => res);
